// sessionStorage counterpart to local-storage.utils.ts — same rationale, see
// createSafeStorage in safe-storage.utils.ts.
import { createSafeStorage } from './safe-storage.utils'

const session = createSafeStorage(() => sessionStorage)

export const safeRead = session.read
export const safeWrite = session.write
export const safeRemove = session.remove
